"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageValue = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var FormatCurrency_1 = require("@CommonFrontend/Utils/FormatCurrency");
var PageValue_css_1 = require("./PageValue.css");
var PageValue = function (_a) {
    var cachedPageValue = _a.cachedPageValue, currencyLocale = _a.currencyLocale;
    if (!cachedPageValue || typeof cachedPageValue.amount !== "number" || !cachedPageValue.currency)
        return null;
    var currencyCode = cachedPageValue.currency.toUpperCase();
    var precision = undefined;
    return (react_1.default.createElement(kaleidoscope_1.Label, { className: PageValue_css_1.currencyStyle }, (0, FormatCurrency_1.formatCurrency)(cachedPageValue.amount, currencyCode, precision, currencyLocale)));
};
exports.PageValue = PageValue;
